import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { BuildHistoryEntry } from '../../build-history';

export interface BuildHistoryDialogData {
  branch: string;
  sha: string;
  versionLabel: string;
  history: BuildHistoryEntry[];
}

@Component({
  selector: 'app-build-history-dialog',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './build-history-dialog.component.html',
  styleUrls: ['./build-history-dialog.component.scss'],
})
export class BuildHistoryDialogComponent implements OnInit {
  public selected: BuildHistoryEntry | null = null;

  constructor(
    private dialogRef: DialogRef,
    @Inject(DIALOG_DATA) public data: BuildHistoryDialogData,
  ) {
  }

  ngOnInit(): void {
    const hist = this.data.history ?? [];
    // Selecteer de commit die bij de draaiende sha hoort, anders de nieuwste.
    this.selected =
      hist.find((h) => h.sha === this.data.sha || this.data.sha?.startsWith(h.sha))
      ?? hist[0]
      ?? null;
  }

  public select(entry: BuildHistoryEntry): void {
    this.selected = entry;
  }

  public close(): void {
    this.dialogRef.close();
  }

  public prLabel(entry: BuildHistoryEntry): string {
    return entry.pr != null ? `PR #${entry.pr}` : entry.sha;
  }

  public relativeTime(iso: string): string {
    if (!iso) {
      return '';
    }
    const then = Date.parse(iso);
    if (Number.isNaN(then)) {
      return iso;
    }
    const sec = Math.max(0, Math.round((Date.now() - then) / 1000));
    if (sec < 60) {
      return 'zojuist';
    }
    const min = Math.round(sec / 60);
    if (min < 60) {
      return `${min} min geleden`;
    }
    const hr = Math.round(min / 60);
    if (hr < 48) {
      return `${hr} uur geleden`;
    }
    const days = Math.round(hr / 24);
    if (days < 30) {
      return `${days} dagen geleden`;
    }
    return new Date(then).toLocaleDateString();
  }

  public absoluteTime(iso: string): string {
    if (!iso) {
      return '';
    }
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) {
      return iso;
    }
    return d.toLocaleString([], { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' });
  }
}
